import { forwardRef } from "react";
import TeamExpensesReport from "./TeamExpensesReport";

/**
 * Marketing Expenses Report — same template as the Team Expenses Report but
 * driven by the "marketing" expense type, matching the Marketing tab on the
 * Performance Overview page.
 */
const MarketingExpensesReport = forwardRef(function MarketingExpensesReport(
  props,
  ref
) {
  return (
    <TeamExpensesReport
      {...props}
      ref={ref}
      expenseType="marketing"
      reportTitle={"Marketing Expenses\nOverview Report"}
    />
  );
});

export default MarketingExpensesReport;
